
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredb0f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredb0f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1sMvO", function(module, exports) {

$parcel$export(module.exports, "register", () => $110e0974a90676f8$export$6503ec6e8aabbaf, (v) => $110e0974a90676f8$export$6503ec6e8aabbaf = v);
var $110e0974a90676f8$export$6503ec6e8aabbaf;
var $110e0974a90676f8$export$f7ad0328861e2f03;
"use strict";
var $110e0974a90676f8$var$mapping = new Map();
function $110e0974a90676f8$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$110e0974a90676f8$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $110e0974a90676f8$var$resolve(id) {
    var resolved = $110e0974a90676f8$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$110e0974a90676f8$export$6503ec6e8aabbaf = $110e0974a90676f8$var$register;
$110e0974a90676f8$export$f7ad0328861e2f03 = $110e0974a90676f8$var$resolve;

});

var $b94da9cdffa58e0c$exports = {};

(parcelRequire("1sMvO")).register(new URL("", import.meta.url).toString(), JSON.parse('["hT37o","index.2e988ea1.js","aS7TZ","repository.7bf0dc01.png","4J3db","watch-fork.43f496f1.png","egi3l","index.aa4b8e4f.css"]'));


//# sourceMappingURL=index.runtime.31cf5f3f.js.map
